export function formatCost(usd: number): string {
  if (usd >= 1000) return `$${(usd / 1000).toFixed(1)}K`;
  if (usd >= 1) return `$${usd.toFixed(2)}`;
  if (usd >= 0.01) return `$${usd.toFixed(2)}`;
  return "$0.00";
}

// Tokens/costos (ex-pricing.ts): umbral K=1.000, incluye tier B.
// NO fusionar con formatNumber — ver S14022.4 design.md D1: los umbrales
// difieren intencionalmente y unificarlos cambiaría el output existente.
export function formatTokens(n: number): string {
  if (n >= 1_000_000_000) return `${(n / 1_000_000_000).toFixed(1)}B`;
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return n.toString();
}

// Conteos del panel de memoria (nodes/edges/patterns/tokens): umbral K=10.000, sin tier B.
// NO fusionar con formatTokens — ver S14022.4 design.md D1.
export function formatNumber(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 10_000) return `${(n / 1_000).toFixed(1)}K`;
  return n.toLocaleString();
}
